<div class="page-social">
    <ul class="page-social-list">
        <li>
            <a href="https://www.linkedin.com/in/jtwashington/" target="_blank">
                <img class="page-social-icon" src="assets/linkedinIcon.png" alt="linkedin" />
            </a>
        </li>
        <li>
            <a href="https://www.pinterest.com/JTWashington1/" target="_blank">
                <img class="page-social-icon" src="assets/pinterestIcon.png" alt="pinterest" />
            </a>
        </li>
    </ul>
</div>
